export var BadgeSize;

(function (BadgeSize) {
  BadgeSize["X_SMALL"] = "xSmall";
  BadgeSize["SMALL"] = "small";
  BadgeSize["MEDIUM"] = "medium";
  BadgeSize["LARGE"] = "large";
  BadgeSize["X_LARGE"] = "xLarge";
})(BadgeSize || (BadgeSize = {}));

export var BadgeVariant;

(function (BadgeVariant) {
  BadgeVariant["PRIMARY"] = "primary";
  BadgeVariant["DESTRUCTIVE"] = "destructive";
  BadgeVariant["INSTRUCTIVE"] = "instructive";
  BadgeVariant["WARNING"] = "warning";
  BadgeVariant["DEFAULT"] = "default";
})(BadgeVariant || (BadgeVariant = {}));